import { create } from 'zustand';

/**
 * READ IT MORE: https://github.com/pmndrs/zustand
 * DO NOT DELETE THIS FILE WHEN RUNNING THIS COMMAND
 * npx unimported
 */
const useStore = create((set) => ({
  token: null,
  company: null,
  user: null, // user must contains profiles otherwise wont work for MF create project won't work correctly
  coupon: null,
  logout: () => null,
  setToken: (token) => set(() => ({ token })),
  setCompany: (company) => set(() => ({ company })),
  setUser: (user) => set(() => ({ user })),
  setCoupon: (coupon) => set(() => ({ coupon })),
  setLogout: (logout) => set(() => ({ logout })),
}));

export default useStore;
